"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSoonestAvailable = exports.hasCleanTaxCredit = exports.useGreatDealTag = exports.maybeHasGreatDealTag = exports.findGreatDeal = void 0;
var TagIds_1 = __importDefault(require("../constants/TagIds"));
// Deal Tags
var findGreatDeal = function (tag) {
    if (tag === void 0) { tag = {}; }
    return (tag === null || tag === void 0 ? void 0 : tag.tagId) === TagIds_1.default.GreatDeal;
};
exports.findGreatDeal = findGreatDeal;
var maybeHasGreatDealTag = function (tileData) {
    var _a = tileData.vehicleTags, vehicleTags = _a === void 0 ? [] : _a;
    var hasTag = vehicleTags.length > 0;
    return hasTag && Boolean(vehicleTags.find(exports.findGreatDeal));
};
exports.maybeHasGreatDealTag = maybeHasGreatDealTag;
var useGreatDealTag = function (tileData) {
    var _a, _b;
    return (_b = (_a = tileData === null || tileData === void 0 ? void 0 : tileData.vehicleTags) === null || _a === void 0 ? void 0 : _a.find(exports.findGreatDeal)) !== null && _b !== void 0 ? _b : null;
};
exports.useGreatDealTag = useGreatDealTag;
var findCleanTaxCredit = function (tag) {
    if (tag === void 0) { tag = {}; }
    return (tag === null || tag === void 0 ? void 0 : tag.tagId) === TagIds_1.default.EVCredit;
};
var hasCleanTaxCredit = function (tileData) {
    var _a = tileData.vehicleTags, vehicleTags = _a === void 0 ? [] : _a;
    var hasTag = vehicleTags.length > 0;
    return hasTag && Boolean(vehicleTags.find(findCleanTaxCredit));
};
exports.hasCleanTaxCredit = hasCleanTaxCredit;
// Availability
var calculateSoonestAvailable = function (_a) {
    var pickup = _a.pickup, delivery = _a.delivery;
    if (pickup == null)
        return delivery !== null && delivery !== void 0 ? delivery : {};
    if (delivery == null)
        return pickup;
    if (pickup.drivingMiles > 150)
        return delivery;
    return delivery.daysToAvailability < pickup.daysToAvailability
        ? delivery
        : pickup;
};
exports.calculateSoonestAvailable = calculateSoonestAvailable;
//# sourceMappingURL=TileFunctions.js.map